module.exports = __webpack_public_path__ + "img/momo_cta_button_point_disable.f90b9b1d.png";